// extracted by mini-css-extract-plugin
module.exports = {"child-menu-list":"ChildMenu_child-menu-list__mKoM2","active":"ChildMenu_active__1cy9N","right-arrow":"ChildMenu_right-arrow__YViv7"};